@if (model?.hasDataToShow) {
  <div class="tile">
    <h5 class="mb-4 font-medium">{{ 'instrument-detail.instrument-statistics.headline' | transloco }}</h5>
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.quoteTime' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.quoteTime) {
          {{ model.quoteTime | todayTimeOrDate }}
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <web-design-system-divider />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.dayHigh' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.dayHigh) {
          {{ model.dayHigh | priceScale: model.priceScale : false : model.currencyCode }}
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <web-design-system-divider />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.dayLow' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.dayLow) {
          {{ model.dayLow | priceScale: model.priceScale : false : model.currencyCode }}
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <web-design-system-divider />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.prevDayClose' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.prevDayClose) {
          {{ model.prevDayClose | priceScale: model.priceScale : false : model.currencyCode }}
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <web-design-system-divider />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.yearHigh' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.yearHigh) {
          {{ model.yearHigh | priceScale: model.priceScale : false : model.currencyCode }}
          @if (model.yearHighDate) {
            am
            {{ model.yearHighDate | date: 'dd.MM.yy' }}
          }
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    <web-design-system-divider />
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="text-color-primary">
        {{ 'instrument-detail.instrument-statistics.rows.yearLow' | transloco }}
      </div>
      <div class="font-medium">
        @if (model?.yearLow) {
          {{ model.yearLow | priceScale: model.priceScale : false : model.currencyCode }}
          @if (model.yearLowDate) {
            am
            {{ model.yearLowDate | date: 'dd.MM.yy' }}
          }
        } @else {
          <div class="text-color-primary">&mdash;</div>
        }
      </div>
    </div>
    @if (model?.performanceCurrentYear) {
      <web-design-system-divider />
      <div class="d-flex d-lg-block d-xl-flex justify-content-between">
        <div class="text-color-primary">
          {{ 'instrument-detail.instrument-statistics.rows.performanceCurrentYear' | transloco }}
        </div>
        <div class="font-medium">
          @if (model?.performanceCurrentYear) {
            <span
              [class.text-color-success]="model.performanceCurrentYear >= 0"
              [class.text-color-error]="model.performanceCurrentYear < 0"
            >
              @if (model.performanceCurrentYear > 0) {
                +
              }
              {{ model.performanceCurrentYear | number: '1.2-2' }} %
            </span>
          } @else {
            <div class="text-color-primary">&mdash;</div>
          }
        </div>
      </div>
    }

    @if (model?.isin && instrumentType !== InstrumentType.Crypto) {
      <web-design-system-divider />
      <a [href]="'https://www.finanzen.net/go/' + model.isin" class="link-secondary d-block mt-3" target="_blank" rel="noopener noreferrer">
        {{ 'instrument-detail.instrument-statistics.more' | transloco }}
      </a>
    }
  </div>
}
